import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Link } from 'site-modules/shared/components/link/link';

import './make-link.scss';

export function MakeLink({
  label,
  className = null,
  iconClassName = null,
  iconContainerClassName = null,
  labelClassName = null,
  ...linkProps
}) {
  return (
    <div className={classnames('make-shopping-link px-1 py-1 text-decoration-none pos-r', className)}>
      <div className="d-flex align-items-center">
        <i
          className={classnames(
            'link-icon d-flex align-items-center justify-content-center size-20',
            iconClassName,
            iconContainerClassName
          )}
          style={{ height: '48px', width: '48px', flexShrink: 0 }}
          aria-hidden
        />
        <div className="ps-0_75">
          <Link {...linkProps} className={classnames('label-text no-focus', labelClassName)}>
            {label}
            <i className="icon-arrow-right3 small ms-0_25" aria-hidden />
          </Link>
        </div>
      </div>
    </div>
  );
}

MakeLink.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  className: PropTypes.string,
  iconClassName: PropTypes.string,
  iconContainerClassName: PropTypes.string,
  labelClassName: PropTypes.string,
};
